require('./Bootstrap.js');
require('./Component');
require('./Filter');
import Vue from 'vue';
import App from './App';
import VueRouter from 'vue-router';
import routes from './Routes.js';
import helper from './plugins/helper';
import httpPlugin from './plugins/http';
import storePlugin from './plugins/store';
import VueLocalStorage from 'vue-localstorage'

import "./css/base.scss";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'

import './App.css';
import '../src/assets/iconfont.css';
import './Theme.scss'
import 'babel-polyfill'
// 自适应
import config from '../project_config.js'
//代理商覆盖配置
var _config = typeof window.agency_config != 'undefined' ? {...config, ...window.agency_config } : config

Vue.config.productionTip = false
    // storePlugin.store.commit('changeAuth',{isLogin:true}) 加载用户信息

//参数设置
Vue.prototype.config = _config;

//favvicon
var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
link.type = 'image/x-icon';
link.rel = 'shortcut icon';
link.href = _config.favicon;
document.getElementsByTagName('head')[0].appendChild(link);

/**
 * plugins
 */
Vue.use(VueRouter);
Vue.use(helper);
Vue.use(storePlugin);
Vue.use(ElementUI);
Vue.use(VueLocalStorage)

/**
 * Router
 */
const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'router-link-active',
    history: true,
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

//http request
Vue.use(httpPlugin, router);

router.beforeEach((to, from, next) => {
    //路由发生变化修改页面title
    if (to.meta.title) {
        document.title = to.meta.title + '-' + _config.site_title
    }

    next()
})

//事件总线
Vue.prototype.$event_bus = new Vue();

new Vue(Vue.util.extend({
    router
}, App)).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js